/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useState,
} from 'react';
import {
  TextField, Box,
  Typography, Dialog, DialogTitle, DialogContent, Button, DialogActions,
} from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import Constants from './Constants';
import { Autocomplete } from '@material-ui/lab';

/**
 * 
 * 
                <TextField
                  onChange={(e) => {
                    changeText(e.target.value, `Phone_Label_${num + 1}`);
                  }}
                  value={country[`Phone_Label_${counter + 1}`]}
                  label={`Phone Label ${num + 1}`}
                />
 */


/*

24/7
24/7 - English
24/7 - French
24/7 - German
24/7 - Italian
24/7 (SMART)
After Hours
Alternative
Alternative Number
Alternative Out of Country
Back Up
Back-Up-After Office Hours
Colombo
Dutch
French
German - Germany Residence 
German International - Luxembourg Residence 
Globe/TM Cells - 24/7
International 
International Danish
International Dutch
International English
International French
International German
International Russian
International Swedish
Landline
Landline 24/7
Main
Mobile
Out of Country
Outside Colombo
*/
const phoneLabels=[
  { label: 'None', value: '' },
  { label: '24/7', value: '24/7' },
  { label: '24/7 - English', value: '24/7 - English' },
  { label: '24/7 - French', value: '24/7 - French' },
  { label: '24/7 - German', value: '24/7 - German' },
  { label: '24/7 - Italian', value: '24/7 - Italian' },
  { label: '24/7 (SMART)', value: '24/7 (SMART)' },
  { label: 'After Hours', value: 'After Hours' },
  { label: 'Alternative', value: 'Alternative' },
  { label: 'Alternative Number', value: 'Alternative Number' },
  { label: 'Alternative Out of Country', value: 'Alternative Out of Country' },
  { label: 'Back Up', value: 'Back Up' },
  { label: 'Back-Up-After Office Hours', value: 'Back-Up-After Office Hours' },
  { label: 'Colombo', value: 'Colombo' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'French', value: 'French' },
  { label: 'German - Germany Residence', value: 'German - Germany Residence' },
  { label: 'German International - Luxembourg Residence', value: 'German International - Luxembourg Residence' },
  { label: 'Globe/TM Cells - 24/7', value: 'Globe/TM Cells - 24/7' },
  { label: 'International', value: 'International' },
  { label: 'International Danish', value: 'International Danish' },
  { label: 'International Dutch', value: 'International Dutch' },
  { label: 'International English', value: 'International English' },
  { label: 'International French', value: 'International French' },
  { label: 'International German', value: 'International German' },
  { label: 'International Russian', value: 'International Russian' },
  { label: 'International Swedish', value: 'International Swedish' },
  { label: 'Landline', value: 'Landline' },
  { label: 'Landline 24/7', value: 'Landline 24/7' },
  { label: 'Main', value: 'Main' },
  { label: 'Mobile', value: 'Mobile' },
  { label: 'Out of Country', value: 'Out of Country' },
  { label: 'Outside Colombo', value: 'Outside Colombo' },
]


export default ({
  param_country, open, afterClose, saveAction, mode,
}) => {
  const times = _.times(7);
  if (param_country === null) {
    return null;
  }

  const orgi_contract=param_country.contracts[0];
  const [country, setCountry] = useState(_.cloneDeep(param_country));


  const changeText = (newText, field) => {
    const modifiedCountry = { ...country };
    modifiedCountry[field] = newText;
    setCountry(modifiedCountry);
  };


  return (
    <Dialog aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title">
        <Typography variant="subtitle1" color="primary">
          {mode === Constants.MODE_ADD_NEW ? 'Add New Country' : ` Edit Country ${param_country.COUNTRY}`}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>

          <Grid item md={6}>
            <TextField
              onChange={(e) => {
                changeText(e.target.value, 'COUNTRY');
              }}
              label="Country"
              value={country.COUNTRY}
            />
          </Grid>

          <Grid item md={6}>
            <TextField
              onChange={(e) => {
                changeText(e.target.value, 'LIVEWELL_ACCESS_CODE');
              }}
              label="Livewell Access code"
              value={country.LIVEWELL_ACCESS_CODE}
            />
          </Grid>


          <Grid item md={6}>
            <TextField
              onChange={(e) => {
                changeText(e.target.value, 'BIOMETRICS_URL');
              }}
              label="Biometrics url"
              value={country.BIOMETRICS_URL}
            />
          </Grid>

                 <Grid item md={6}>
      
          </Grid>


          {times.map((num, counter) => (
            <React.Fragment key={num}>
              <Grid item md={6} height="60px">
                <TextField
                  onChange={(e) => {
                    changeText(e.target.value, `Phone_${counter + 1}`);
                  }}
                  value={country[`Phone_${counter + 1}`]}
                  label={`Phone ${num + 1}`}
                />
              </Grid>
              <Grid item md={6}  height="60px">

    <Autocomplete
            popoverProps={{ style: { width: 'auto' } }}
            style={{ width: '100%' }}
            onChange={(event, item) => {
               
                changeText(item.value, `Phone_Label_${counter + 1}`);
                
            }}
             value={country[`Phone_Label_${counter + 1}`]}
            options={phoneLabels}
            disableClearable
            autoSelect
            renderOption={(option) => <strong>{option?.label}</strong>}
            getOptionLabel={option=>{
           
            return option?.label? option.label: option||'';
            }}
           
            renderInput={(params) => <TextField fullWidth {...params} label={`Phone Label ${num + 1}`} variant="outlined" />}
          />
         


              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <hr />
        <Typography variant="subtitle1" color="primary">
          Contract
        </Typography>
        <Grid container spacing={1}>
          <Grid item md={6}>
            <TextField 
             
              onChange={(e) => {
                country.contracts[0]=e.target.value;
                const modifiedCountry = { ...country };
                setCountry(modifiedCountry);
              }}
              label="Contract Id"
              value={country.contracts[0]}
            />
          </Grid>
        </Grid>


      </DialogContent>
      <DialogActions>
        <Box textAlign="center" marginTop={5}>
          <Button

            onClick={() => {
              country.orgi_contract=orgi_contract;
              saveAction(country);
            }}


            color="primary"
          >
            Save
          </Button>
          <Button
            onClick={() => {
              afterClose();
            }}
            color="secondary"
          >
            Cancel
          </Button>

        </Box>
      </DialogActions>
    </Dialog>
  );
};
